import { useRouter } from 'next/router'

import { getRouteWithDomain } from '@/src/domains/next-roots/utils/getRouteWithDomain'

export const useCanonicalUrl = () => {
  const { pathname, query } = useRouter()

  return getRouteWithDomain(pathname, query)
}
